import React, { useState, useEffect } from "react";
import CustomSidenav from "../../components/sidebar/Sidebar";
import DashboardRoutes from "../../utils/DashboardRoutes";
import {
  Breadcrumb,
  Button,
  Col,
  Dropdown,
  Flex,
  Layout,
  MenuProps,
  Row,
  Space,
  Spin,
  Tooltip,
  Typography,
} from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  SettingOutlined,
  LogoutOutlined,
  WhatsAppOutlined,
  UserOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import { getPageInfo } from "../../utils/pageInfo";
import "../../assets/css/dashboard.css";

const { Header, Content } = Layout;
const { Text } = Typography;

interface DashboardProps {
  signOut: () => void;
  user_data: any;
}

const Dashboard: React.FC<DashboardProps> = ({ signOut, user_data }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isMobileSiderVisible, setIsMobileSiderVisible] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const { title, breadcrumb } = getPageInfo(location.pathname);

  // Manejar cierre de sesión
  const handleSignOut = async () => {
    await signOut();
    navigate("/");
    window.location.reload();
  };

  // Detectar si la pantalla es móvil
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Items del menú de usuario
  const items: MenuProps["items"] = [
    {
      label: (
        <Link rel="noopener noreferrer" to="/dashboard/whatsapp-integration">
          Integración
        </Link>
      ),
      icon: <WhatsAppOutlined />,
      key: "0",
    },
    {
      label: (
        <Link rel="noopener noreferrer" to="/dashboard/user-profile">
          Perfil
        </Link>
      ),
      icon: <UserOutlined />,
      key: "1",
    },
  ];

  return (
    user_data ? (
      <Layout
        hasSider
        style={{ minHeight: "100vh" }}
        className="layout-dashboard"
      >
        {/* Custom Sidenav */}
        <CustomSidenav
          signOut={signOut}
          user_data={user_data}
          isMobile={isMobile}
          isMobileSiderVisible={isMobileSiderVisible}
          onToggleMobileSider={() =>
            setIsMobileSiderVisible(!isMobileSiderVisible)
          }
        />
        <Layout>
          <Header style={{ background: "#FFFFFF" }}>
            <Row gutter={[24, 0]}>
              <Col span={12} xs={12} sm={12} md={6}>
                <Space align="start" direction="vertical" size={"small"} style={{ height: "100%", width: "100%", justifyContent: "center" }}>
                  {!isMobile && (
                    <Breadcrumb>
                      {breadcrumb.map((item, index) => (
                        <Breadcrumb.Item key={index}>{item}</Breadcrumb.Item>
                      ))}
                    </Breadcrumb>
                  )}
                  <div className="ant-page-header-heading">
                    <span
                      className="ant-page-header-heading-title"
                    >
                      {title}
                    </span>
                  </div>
                </Space>
              </Col>
              <Col span={12} xs={12} sm={12} md={18} className="header-control">
                <Flex align="center" justify="end" gap={8}>
                  {!isMobile && <Text>{user_data?.family_name}</Text>}
                  <Dropdown menu={{ items }} trigger={['click']}>
                    <Button type="text" icon={<SettingOutlined />} onClick={(e) => e.preventDefault()} />
                  </Dropdown>
                  <Tooltip title="Cerrar sesión">
                    <Button
                      type="text"
                      icon={<LogoutOutlined />}
                      onClick={handleSignOut}
                    />
                  </Tooltip>
                  {isMobile && (
                    <Button
                      type="text"
                      icon={<MenuOutlined />}
                      onClick={() => setIsMobileSiderVisible(true)}
                    />
                  )}
                </Flex>
              </Col>
            </Row>
          </Header>
          <Content style={{ padding: "20px", overflow: "auto" }}>
            <div style={{ borderRadius: 10 }}>
              <DashboardRoutes
                user_data={user_data}
              />
            </div>
          </Content>
        </Layout>
      </Layout>
    ) : <Spin fullscreen />
  );
};

export default Dashboard;
